import {
  DataTablePrimeReact,
  PaginationERP,
  TableERP,
} from "@finanedi.es/storybook"
import {
  CuentaContableEmpresaByFilterParamsProps,
  cuentasContablesByFilterCall,
  deleteCuentaContableById,
  getCuentaContableByFilter,
  getCuentaContableById,
} from "api/CuentaContableEmpresa.service"
import { useCuentaContableCuentaAll } from "api/CuentaContable_Cuenta.hook"
import { CuentaContableEmpresaReadingDtoProps } from "api/DTOs/CuentaContableEmpresaReadingDto"
import { useLineaAsientoDescuadre } from "api/LineaAsientoContable.hook"
import DeleteModal from "common/components/Modal/DeleteModal"
import ModalCrearCuentaContable from "common/components/ModalCrearCuentaContable"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import notification from "common/utils/notification"
import { DATE_YYYY_MM_DD } from "constants/formatoFechas"
import { RESP_200 } from "constants/numbers"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { format } from "date-fns"
import ModalAsientoContable from "features/Contabilidad/components/ModalAsientoContable/ModalAsientoContable"
import { useFilterMenu } from "hooks/useFilterMenu"
import { useCallback, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { UUIDType } from "uuid"
import { FilterMenu } from "./components/FilterMenu"
import { CUADRO_CUENTAS_COLUMNS } from "./constants/CuadroCuentasColumns"
import { CUADRO_CUENTAS_CONTABLES_DEFAULT_FILTER } from "./constants/cuadroCuentasContablesFilters"
import { getGenerateExcelCuentaContable } from "./services/CuentasContablesServices"
import "./style.scss"

interface CuentaContable {
  id: string
  cuentaContableId: string
  nombre: string
  numero: string
}

export interface ShowDelete {
  id: string | null
  show: boolean
}

const CuadroCuentasContables = () => {
  const { t } = useTranslation()
  const history = useHistory()

  useLineaAsientoDescuadre()

  const defaultFilters = () => {
    const storedData = JSON.parse(
      sessionStorage.getItem("cuadroCuentasContableFilters") ?? "null"
    )
    if (storedData === null) return CUADRO_CUENTAS_CONTABLES_DEFAULT_FILTER(t)
    return {
      ...storedData,
      date: !storedData?.date
        ? undefined
        : [
            new Date(storedData?.date?.[0]),
            storedData?.date?.[1] ? new Date(storedData?.date?.[1]) : null,
          ],
    }
  }
  const [cuadroCuentasFilters, setCuadroCuentasFilters] =
    useState(defaultFilters)

  const [sortingCriteria, setSortingCriteria] = useState<
    CuentaContableEmpresaByFilterParamsProps["SortingCriteria"]
  >({
    property: undefined,
    sort: undefined,
  })
  const [pagination, setPagination] = useState(cuadroCuentasFilters.pagination)

  const dtRef =
    useRef<DataTablePrimeReact<CuentaContableEmpresaReadingDtoProps[]>>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }

  const [showDelete, setShowDelete] = useState<ShowDelete>({
    id: null,
    show: false,
  })
  const [openModalCuenta, setOpenModalCuenta] = useState(false)
  const [showModalAsiento, setShowModalAsiento] = useState(false)
  const { handleDirectDownloadExcel } = useDownloadFileContext()
  const [localCuentaContable, setLocalCuentaContable] =
    useState<CuentaContable | null>(null)
  const { cuentasContablesEmpresas: allCuentasContables } =
    useCuentaContableCuentaAll()
  const fetchItems = useCallback(
    () => async (queryParams: CuentaContableEmpresaByFilterParamsProps) => {
      cuentasContablesByFilterCall?.cancel()
      const data = await getCuentaContableByFilter({
        ...queryParams,
        SkipCount: queryParams.SkipCount ?? pagination.skipCount,
        SortingCriteria: queryParams.SortingCriteria,
        MaxResultCount: queryParams.MaxResultCount ?? pagination.itemsPerPage,
      })
      return data
    },
    [pagination.itemsPerPage, pagination.skipCount]
  )

  const { items, isLoading, totalCount, setServiceQuery, fetchTableData } =
    useFilterMenu({
      serviceCall: fetchItems,
    })

  const addCuentaEmpresaId = async (id: string | UUIDType) => {
    try {
      const data = await getCuentaContableById(id)
      // @ts-expect-error TS(2345): Argument of type 'CuentaContableEmpresaReadingSimp...
      setLocalCuentaContable(data)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
    setOpenModalCuenta(true)
  }

  const deteleCuentaEmpresaId = async (id: string) => {
    try {
      const resp = await deleteCuentaContableById(id)
      if (resp.status === RESP_200) {
        notification.success({
          body: `${t("cuadroCuentas.deleteMsg")}`,
        })
        handleResetPagination()
        fetchTableData()
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
    setShowDelete({ id: null, show: false })
  }

  useEffect(() => {
    const updateCuadroCuentasFilters = {
      ...cuadroCuentasFilters,
      pagination,
    }
    sessionStorage.setItem(
      "cuadroCuentasContableFilters",
      JSON.stringify(updateCuadroCuentasFilters)
    )
  }, [pagination, cuadroCuentasFilters])

  const exportToExcel = async () => {
    const req = await getGenerateExcelCuentaContable({
      FechaFinMovimiento: cuadroCuentasFilters?.date?.[1]
        ? format(cuadroCuentasFilters.date[1], DATE_YYYY_MM_DD)
        : "",
      FechaInicioMovimiento: cuadroCuentasFilters?.date?.[0]
        ? format(cuadroCuentasFilters.date[0], DATE_YYYY_MM_DD)
        : "",
      TieneMovimientos: cuadroCuentasFilters.filtroSwitch.tieneMovimiento,
      CuentaContableGrupo:
        cuadroCuentasFilters.selectedType.tipo !== undefined
          ? cuadroCuentasFilters.selectedType
          : null,
      maxResult: 100,
      params: "",
      skipCount: 0,
      sortingCriteria: null,
    })
    handleDirectDownloadExcel(req, `${t("cuadroCuentas.excelFileName")}`)
  }

  const handleAlternativeAction = () => {
    setOpenModalCuenta(false)
    fetchTableData()
  }

  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)

  const onRowClick = async ({
    data,
  }: {
    data: CuentaContableEmpresaReadingDtoProps
  }) => {
    if (!data.id) return
    history.push(`${ROUTES.LIBRO_MAYOR}/${data.id}`)
  }

  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
  }
  return (
    <div className='tw-flex tw-flex-col tw-order-2 tw-z-10 tw-relative tw-w-full tw-max-h-screen tw-h-full tw-bg-gray tw-overflow-x-hidden tw-overflow-y-hidden custom-scrollbar'>
      <div className='tw-flex-none tw-bg-white tw-shadow-md'>
        <FilterMenu
          serviceQuery={setServiceQuery}
          sortingCriteria={sortingCriteria}
          skipCount={pagination.skipCount}
          maxResultCount={pagination.itemsPerPage}
          resetPagination={handleResetPagination}
          toggleModalAsientos={() => setShowModalAsiento(!showModalAsiento)}
          toggleModalCuenta={() => setOpenModalCuenta(!openModalCuenta)}
          exportToExcel={() => exportToExcel()}
          cuadroCuentasFilters={cuadroCuentasFilters}
          setCuadroCuentasFilters={setCuadroCuentasFilters}
        />
      </div>

      <div className='tw-flex tw-flex-col tw-h-[calc(100%-82px)] tw-relative '>
        <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
          <TableERP
            refTable={dtRef}
            columns={CUADRO_CUENTAS_COLUMNS(
              t,
              addCuentaEmpresaId,
              setShowDelete
            )}
            className='tw-h-full !tw-z-0'
            columnResizeMode='expand'
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            removableSort
            value={items}
            showGridlines
            lazy
            dataKey='id'
            scrollable
            size='small'
            onRowClick={onRowClick}
            loading={isLoading}
          />
        </div>
        <PaginationERP
          className={PAGINATION_STYLES}
          totalRecords={totalCount}
          first={pagination.skipCount}
          rows={pagination.itemsPerPage}
          resetScroll={() => dtRef.current && dtRef.current?.resetScroll()}
          setPagination={setPagination}
          optionDropdown={[10, 20, 50, 100]}
          texts={{
            textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
            textCurrentPageReport: `${t("pagination.from")}`,
          }}
        />
      </div>

      <ModalAsientoContable
        idToEdit={false}
        show={showModalAsiento}
        setShow={setShowModalAsiento}
        updateTable={fetchTableData}
      />
      {openModalCuenta && (
        <ModalCrearCuentaContable
          visible={openModalCuenta}
          onHide={() => {
            setLocalCuentaContable(null)
            setOpenModalCuenta(false)
          }}
          editing={localCuentaContable ?? false}
          initialData={
            localCuentaContable
              ? {
                  tipoCuenta: Number(localCuentaContable?.cuentaContableId),
                  nombre: localCuentaContable?.nombre,
                  numero: localCuentaContable?.numero,
                  data: localCuentaContable,
                }
              : false
          }
          cuentaPorDefecto={
            localCuentaContable
              ? Number(localCuentaContable?.cuentaContableId)
              : null
          }
          alternativeAction={handleAlternativeAction}
          listaDeCuentas={allCuentasContables}
          listaDeCuentasBase={allCuentasContables}
          refreshFetchData={() => fetchTableData()}
        />
      )}
      <DeleteModal
        visible={showDelete.show}
        onHide={() => setShowDelete({ id: null, show: false })}
        size='small'
        iconType='remesas'
        buttonLabel={t("bancos.delete.confirmButton")}
        title={t("cuadroCuentas.deteleTitle")}
        message={t("bancos.delete.msg")}
        // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
        onConfirm={() => deteleCuentaEmpresaId(showDelete?.id)}
      />
    </div>
  )
}

export default CuadroCuentasContables
